import * as constants from '../constants';

const initialState = {};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case constants.getCardDefaults.success: {
            return action.payload;
        }

        case constants.getCardDefaults.error:
        case constants.getCardDefaults.try: {
            return initialState;
        }

        default:
            return state;
    }
}